import Grid from '@mui/material/Unstable_Grid2';
import {
  EntityTechdocsContent,
  isTechDocsAvailable,
} from '@backstage/plugin-techdocs';
import { RELATION_OWNED_BY } from '@backstage/catalog-model';
import { EntityLayout } from '@internal/plugin-medidata-catalog-react';
import { commonContent, maturityScoreContent } from './commonContent';

export const documentationEntityPage = (
  <EntityLayout parentEntityRelations={[RELATION_OWNED_BY]}>
    <EntityLayout.Route path="/" title="Overview">
      <Grid container spacing={1} alignItems="stretch">
        {commonContent}
      </Grid>
    </EntityLayout.Route>

    <EntityLayout.Route path="/maturity" title="Maturity">
      {maturityScoreContent}
    </EntityLayout.Route>

    <EntityLayout.Route path="/docs" title="Docs" if={isTechDocsAvailable}>
      <EntityTechdocsContent />
    </EntityLayout.Route>
  </EntityLayout>
);
